import type { AxiosRequestConfig } from 'axios'
import qs from 'qs'

const API_LIST = [
  'avatar_verify',
  'bank_verify',
  'change_information',
  'game_list',
  'regist',
  'reset_password',
  'send_reset_password',
  'send_verification_email',
  'send_verification_sms',
  'upload_pictures',
  'verify_email_code',
  'verify_reset_password',
  'verify_sms_code',
  'washcodeself_receive',
  'verify_parameters',
  'play_game_websocket',
  'cancel_debit',
]

export function isApi2(requestConfig: AxiosRequestConfig) {
  const type =
    requestConfig.data instanceof FormData
      ? requestConfig.data.get('type')
      : typeof requestConfig.data === 'string'
      ? qs.parse(requestConfig.data).type
      : ''

  const submitType =
    requestConfig.data instanceof FormData
      ? requestConfig.data.get('submit_type')
      : typeof requestConfig.data === 'string'
      ? qs.parse(requestConfig.data).submit_type
      : ''

  if (typeof type === 'string') {
    return API_LIST.includes(type)
  }

  if (typeof submitType === 'string') {
    return API_LIST.includes(submitType)
  }

  return false
}
